<template>
  <div>
    <div class="cover" v-if="showCover">
      <div class="time">{{time}}</div>
      <img :src="require('@/assets/img/save/cover.png')" alt="">
    </div>
    <div class="save-code" v-else>
      <div class="banner">
        <div class="banner-dots">
          <span v-for="i in 4" :key="'d'+i" class="dot"></span>
        </div>
        <div class="banner-lines">
          <span v-for="i in 3" :key="'l'+i" class="line"></span>
        </div>
        <h1 class="banner-title">{{ $t('saveCode.pageTitle') }}</h1>
        <div class="banner-row">
          <span class="banner-house">{{ houseName }}</span>
          <div class="banner-btns">
            <span class="banner-btn-outline" @click="toLogin">{{ $t('saveCode.login') }}</span>
            <span class="banner-btn-primary" @click="toRegister">{{ $t('saveCode.selfRegister') }}</span>
          </div>
        </div>
        <svg class="banner-svg" viewBox="0 0 400 100" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20,100 L20,60 L40,60 L40,40 L60,40 L60,70 L80,70 L80,30 L100,30 L100,80 L120,80 L120,50 L140,50 L140,90 L160,90 L160,20 L180,20 L180,60 L200,60 L200,40 L220,40 L220,70 L240,70 L240,30 L260,30 L260,80 L280,80 L280,50 L300,50 L300,90 L320,90 L320,20 L340,20 L340,60 L360,60 L360,40 L380,40 L380,70 L400,70 L400,100 Z" fill="currentColor" opacity="0.12" />
        </svg>
      </div>
      <div class="user-info">
        <div class="user-info-title">
          <span v-if="$lang === 'zh-CN'">{{ managerNum }}员信息</span>
          <span v-else>{{ userInfoList.length }} Staff</span>
        </div>
        <div style="display: flex; justify-content: space-between; flex-wrap: wrap">
          <div class="user-info-item" v-for="item in userInfoList">
            <img :src="item.avatar" alt="">
            <div>
              <div class="post">{{ $lang === 'en-US' && item.workNameEn ? item.workNameEn : item.workName }}</div>
              <div class="name">{{ $lang === 'en-US' && item.nameEn ? item.nameEn : item.name }}</div>
              <div class="mobile">{{ getMobile(item.mobile) }}</div>
            </div>
          </div>

        </div>
      </div>
      <div class="notice-card" @click="goNotice()">
        <div class="notice-card-row">
          <div>
            <h3 class="notice-card-title">{{ $t('saveCode.notice') }}</h3>
            <p class="notice-card-sub">{{ noticeList[0] ? ($lang === 'zh-CN' ? noticeList[0].title : (noticeList[0].titleEn || noticeList[0].title)) : '' }}</p>
          </div>
          <van-icon name="arrow" color="#bbb" />
        </div>
      </div>

      <div class="terms-card" @click="openTerms">
        <div class="terms-card-row">
          <div>
            <h3 class="terms-card-title">{{ $t('saveCode.checkInNotice') }}</h3>
            <p class="terms-card-sub">{{ $t('saveCode.clickToView') }}</p>
          </div>
          <van-icon name="arrow" color="#bbb" />
        </div>
      </div>
    </div>
    <div id="mapDiv" v-show="false"></div>
    <van-dialog
      v-model="showVerify"
      cancel-button-text="取消"
      confirm-button-text="确定"
      show-confirm-button
      show-cancel-button
      @confirm="verifyConfirm"
      @cancel="showVerify = false">
      <div class="verify">
        <van-field name="联系电话" label="联系电话" placeholder="请输入联系电话" v-model="dataForm.mobile"></van-field>
        <van-field name="短信验证码" label="短信验证码" placeholder="请输入验证码" v-model="dataForm.code">
          <template #button>
            <van-button v-if="btnSendText == '发送验证码'" size="small" type="info" @click="getCode" style="border: none">{{btnSendText}}</van-button>
            <div v-else class="btnSendText">{{btnSendText}}</div>
          </template>
        </van-field>
      </div>
    </van-dialog>

    <van-popup v-model="showTerms" position="bottom" round :close-on-click-overlay="false" class="terms-popup">
      <div class="terms-header">
        <h2 class="terms-title" v-if="$lang === 'zh-CN'">租房须知</h2>
        <h2 class="terms-title" v-else>Rental Notice</h2>
        <p class="terms-subtitle" v-if="$lang === 'zh-CN'">请仔细阅读以下条款</p>
        <p class="terms-subtitle" v-else>Please read the following terms carefully</p>
        <span class="terms-close" @click="showTerms = false">&times;</span>
      </div>
      <div class="terms-body">
        <template v-if="$lang === 'zh-CN'">
          <div class="terms-section"><h4>一、居住</h4><h5>1、租房</h5>
            <p><strong>1.1 在哪儿租房？</strong></p><p>您可以选择正规的租房中介公司帮您寻找合适的房源。在中国，不少租房中介公司都有自己的线上平台，您可以提前在网站上，根据租金、地段、房屋状况等条件搜索房源。当然，您也可以直接去租房中介公司的门店，找租房经纪人当面详谈。通常，租房中介会陪您一同上门考察房源。</p>
            <p><strong>1.2 如何签订租房合同？</strong></p><p>若您对所看的房屋感到满意并确定了租赁意向，您需要同房东签订租房合同，约定租赁期限、租赁用途、租赁价格、修缮责任等条款，以及双方的其他权利和义务，并交付相关费用，包括押金和租金，再向房产管理部门登记备案。为了尽可能避免租房中的纠纷，一般会签订双语租房合同，但应尽量以其中一种语言为准，以免产生歧义。</p>
            <p><strong>1.3 如何办理住宿登记？</strong></p><p>根据规定，您需要在入住的24小时之内，由本人或者房东，前往当地公安机关办理住宿登记，否则将会被处罚。入住房屋后，您必须遵守合同规定，保持房屋的安全和清洁。请注意居住时保持安静，不要大声喧哗，否则很可能遭到邻居的投诉。</p>
          </div>
          <div class="terms-section"><h5>2、购房</h5>
            <p><strong>2.1 是否有购房资格？购房数量是否有限制？</strong></p><p>在购房前，您需要确定自己是否具有购房资格。关于外国人在中国购买商品房的政策，各地有所不同，但总体上，在境内设立分支、代表机构的境外机构和在境内工作、学习的境外个人，可以购买符合实际需要的自用、自住商品房。另外，对于实施住房限购政策的城市，应当符合当地政策规定。</p>
            <p><strong>2.2 产权登记须提供哪些材料？</strong></p><p>在办理商品房预售合同备案和房屋产权登记时，您应当提供：1. 有关部门出具的境外个人（不含港澳台居民和华侨）在境内工作超过一年的证明；港澳台居民和华侨在境内工作、学习和居留的证明。2. 境外个人名下在境内无其他住房的书面承诺。</p>
            <p><strong>2.3 如何申请购房结汇？</strong></p><p>境外机构和个人申请购房结汇，应当严格按照《关于规范房地产市场外汇管理有关问题的通知》办理。</p>
            <p><strong>2.4 土地使用年限是多长？</strong></p><p>在中国，土地使用权都有一定的年限，从40年到70年不等，其中商业、旅游、娱乐用地为40年，住宅用地为70年。2020年1月1日起施行的《中华人民共和国民法典》第359条明确规定"住宅建设用地使用权期限届满的，自动续期"。您可以委托当地的房地产中介，协助您办理寻找房源、价格谈判、签订合同、交易过户等手续。</p>
            <p><strong>2.5 境外机构能买房吗？</strong></p><p>在境内设立分支、代表机构的境外机构只能在注册城市购买办公所需的非住宅房屋。法律法规另有规定的除外。</p>
            <p class="terms-tip">小贴士 | 住房和城乡建设部 www.mohurd.gov.cn</p>
          </div>
          <div class="terms-section"><h4>二、交通</h4>
            <p><strong>2.1 去哪里办公交卡？</strong></p><p>可以在地铁站、公交站或者手机公交App上办理。</p>
            <p><strong>2.2 怎么办公交卡？</strong></p><p>公交卡可直接购买，不需要身份证明文件。</p>
            <p><strong>2.3 怎么给公交卡充值？</strong></p><p>在任一地铁站可以充值，也可以在手机公交App上充值。可使用现金、微信、支付宝以及手机公交App上支持的支付方式等。</p>
            <p><strong>2.4 外国人可以骑共享单车吗？</strong></p><p>可以。使用微信、支付宝或者下载共享单车要求的手机App扫码后使用。</p>
            <p><strong>2.5 在中国怎么坐出租汽车？</strong></p><p>您可以在路边停车处招手示意，也可以通过打车App或微信、支付宝、地图软件的打车接口进行网络叫车服务，还可以拨打出租汽车公司的叫车服务电话叫车。</p>
            <p><strong>2.6 如何申请中国临时驾驶许可？</strong></p><p>持护照和有效签证等身份证件、境外机动车驾驶证到入境地或居住地公安机关交通管理部门车辆管理所申请小型汽车或摩托车临时驾驶许可。临时驾驶许可有效期内可多次入境使用，无须重新申请。持临时驾驶许可的，可以驾驶自带的临时入境机动车或租赁的中国机动车。驾驶自带临时入境机动车的，临时驾驶许可准驾车型应当与自带机动车的车型一致。驾驶租赁中国机动车的，临时驾驶许可的准驾车型为小型汽车和小型自动挡汽车。</p>
            <p><strong>2.7 如何申请换领中国正式驾驶证？</strong></p><p>持护照、入境居（停）留期为3个月以上的有效签证或者停留、居留证件等有效身份证件，境外机动车驾驶证，以及公安机关核发的住宿登记证明和县级以上医疗机构出具的有关身体条件证明到居住地公安机关交通管理部门车辆管理所申请换领驾驶证。申请中国临时驾驶许可或正式驾驶证的外国人，所持境外机动车驾驶证属于非中文表述的，还应当出具中文翻译文本。</p>
            <p><strong>2.8 如何在中国考领机动车驾驶证？</strong></p><p>年满18岁，持护照、入境居（停）留期为3个月以上的有效签证或者停留、居留证件等有效身份证件，以及公安机关核发的住宿登记证明和县级以上医疗机构出具的有关身体条件证明到居留地或居住地公安机关交通管理部门车辆管理所申请考领驾驶证，考试合格后，即可获得中国正式机动车驾驶证。</p>
            <p><strong>2.9 怎样在中国买到一张火车票？</strong></p><p>持本人有效身份证件（护照或外国人永久居留身份证）到火车站或代售点购买。也可以登录12306网站（www.12306.cn）凭借有效护照编号购票，届时再去车站或代售点取票。</p>
          </div>
          <div class="terms-section"><h4>三、通信</h4>
            <p><strong>3.1 从国外怎么给中国北京的座机打电话？</strong></p><p>86-10（北京区号）-XXXXXXXX</p>
            <p><strong>3.2 在中国怎么给中国北京的座机打电话？</strong></p><p>010（北京区号）-XXXXXXXX</p>
            <p><strong>3.3 去哪里办电话、手机、宽带，要带什么？</strong></p>
            <p>您可以登录中国的电信运营商官方网站或者持本人有效护照前往营业厅。例如：</p>
            <p>中国移动通信 CHINA MOBILE | www.10086.cn</p>
            <p>中国联通 China unicom | www.10010.com</p>
            <p>中国电信 CHINA TELECOM | www.chinatelecom.com.cn</p>
            <p>⚠️ 在中国境内办理电话卡需进行实名认证，如不再使用，需前往营业厅办理销户手续。</p>
          </div>
        </template>
        <template v-else>
          <div class="terms-section"><h4>I. Accommodation</h4><h5>1. Renting Accommodation</h5>
            <p><strong>1.1 Where to rent accommodation?</strong></p><p> You can use a formal real estate agency to look for housing. In China, many real estate agencies have their own online platforms. You can search for apartments in advance on the website according to the price, location, apartment type, and other conditions. Of course, you can also go directly to the real estate agencies and talk to the agents in person. Usually, an agent will accompany you to visit the apartments.</p>
            <p><strong>1.2 How to sign a rental contract?</strong></p><p> If you are satisfied with the apartment you have seen and decide to rent it, you need to sign a rental contract with the landlord, agreeing on the terms of the duration, purpose, price, maintenance responsibilities, and other rights and obligations of both parties, and pay related expenses, including deposit and rent, and then register with the real estate administration department. In order to avoid disputes in renting, bilingual rental contracts are generally signed, but one language should prevail as far as possible to avoid ambiguity.</p>
            <p><strong>1.3 How to complete residence registration?</strong></p><p> You or the host shall go to the local police station for residence registration within 24 hours after you move in, otherwise you will face punishment. After moving into the apartment, you must abide by the contract and keep the house safe and clean. Please keep noise to a minimum in the apartment, or you may get complaints from neighbors.</p>
          </div>
          <div class="terms-section"><h5>2. Purchasing Real Estate Property</h5>
            <p><strong>2.1 Am I eligible to purchase real estate property? Is there a limit on the number of real estate properties to purchase?</strong></p><p> Before purchasing a real estate property, you need to check whether you are eligible to do so. Policies regarding foreigners' purchase of commercial real estate property in China vary from place to place, but in general, overseas organizations that have branches and representative offices in China, and overseas individuals working and studying in China can purchase self-use and self-occupied commercial properties that meet their actual needs. In addition, for cities that implement housing purchase restrictions, you should comply with local policies and regulations.</p>
            <p><strong>2.2 What materials are needed for property registration?</strong></p><p> When filing the pre-sale contract of commercial housing and the housing property registration, you should provide: 1. A certificate issued by relevant departments that the foreign individual (excluding residents of Hong Kong, Macao, Taiwan regions of China and overseas Chinese) has worked in China for more than one year, or that residents of Hong Kong, Macao, Taiwan regions of China and overseas Chinese work, study, and reside in China. 2. A written commitment that there is no other housing in the country under the same name.</p>
            <p><strong>2.3 How to apply for foreign exchange settlement for real estate purchase?</strong></p><p> Overseas organizations and individuals applying for the settlement of foreign exchange for real estate purchase shall strictly follow the Notice on Regulating the Administration of Foreign Exchange in the Real Estate Market.</p>
            <p><strong>2.4 What is the duration of land-use rights?</strong></p><p> In China, there is a limit on duration for land-use rights ranging from 40 to 70 years: a maximum of 40 years for the use of commerce, tourism, and entertainment, and 70 years for residential use. The Civil Code of the People's Republic of China that came into effect on January 1, 2020 clearly stipulates in Article 359 that "when the land-use rights for residential use expire, they will be automatically renewed." You can entrust a local real estate agency to assist you in house hunting, price negotiation, contract signing, transaction transfers, and other procedures.</p>
            <p><strong>2.5 Can overseas organizations purchase a real estate property?</strong></p><p> Overseas organizations that set up branches and representative offices in China can only purchase non-residential properties needed for office work in their registered cities, unless laws and regulations state otherwise.</p>
            <p class="terms-tip">TIPS | Ministry of Housing and Urban-Rural Development (MOHURD) www.mohurd.gov.cn</p>
          </div>
          <div class="terms-section"><h4>II. Transportation</h4>
            <p><strong>2.1 Where to get a public transportation card?</strong></p><p> You can get one at metro stations, bus stations, or via related mobile apps.</p>
            <p><strong>2.2 How to get a public transportation card?</strong></p><p> You can buy one directly without identification documents.</p>
            <p><strong>2.3 How to recharge a public transportation card?</strong></p><p> You can recharge the card at any metro station or on the related mobile apps. You can use cash, WeChat, Alipay, or other payment methods supported on the mobile apps.</p>
            <p><strong>2.4 Can foreigners use shared bikes?</strong></p><p> Yes. You can use them by scanning the QR code on the shared bikes through WeChat, Alipay, or other relevant mobile apps.</p>
            <p><strong>2.5 How to take a taxi in China?</strong></p><p> You can get a taxi by simply flagging one down at a taxi standing zone on the street. You can also use taxi apps, or ride hailing services via WeChat, Alipay, or various map apps, or make a reservation phone call to a taxi company.</p>
            <p><strong>2.6 How to apply for a temporary driving license?</strong></p><p> You can apply for a temporary driving license at the local vehicle administration office of the traffic administration department of the public security bureau where you enter China or reside, by providing your ID documents, such as a passport and valid visa, and overseas driving license. A temporary driving license can be used for multiple entries to China before the expiry date without reapplication. You can drive your own motor vehicle brought to China or a rented one in China with a temporary driving license. For those who bring their own motor vehicles to China, the type of vehicle should be the same as the one permitted on the temporary driving license. For those who rent motor vehicles in China, small cars and small automatic vehicles are permitted with a temporary driving license.</p>
            <p><strong>2.7 How to convert your driving license in China?</strong></p><p> You can apply to convert your temporary driving license to a formal Chinese one at the local vehicle administration office of the traffic administration department of the public security bureau where you reside, with the following documents: valid ID documents such as passport, valid visa for stay/residence of more than 3 months, your overseas driving license, the residence registration certificate issued by the local police station, and the physical health condition certificate issued by medical organizations at or above the county level. Foreigners who apply for a temporary driving license or a formal driving license in China shall also have their overseas driving license translated into Chinese.</p>
            <p><strong>2.8 How to take a driving test in China?</strong></p><p> You can apply for the test of a formal driving license at the local vehicle administration office of the traffic administration department of the public security bureau where you reside if you are above 18 years old, with the following documents: valid ID documents such as passport, valid visa for stay/residence of more than 3 months, the residence registration certificate issued by the local police station, and the physical health condition certificate issued by medical organizations at or above the county level. If you pass the test, you can get a formal motor vehicle driving license in China.</p>
            <p><strong>2.9 How to buy a train ticket in China?</strong></p><p> You can buy a train ticket at a railway station or a ticket agency with a valid ID (passport or Foreign Permanent Residence ID Card). You may also log on to the China Railway's website (www.12306.cn) to buy a ticket with a valid passport number, and then go to a railway station or a ticket agency to collect the ticket.</p>
          </div>
          <div class="terms-section"><h4>III. Telecommunications</h4>
            <p><strong>3.1 How to make an international landline call to Beijing from abroad?</strong></p><p> 86-10 (Beijing Area/Telephone Code) - XXXXXXXX</p>
            <p><strong>3.2 How to make a landline call to Beijing from within China?</strong></p><p> 010 (Beijing Area/Telephone Code) - XXXXXXXX</p>
            <p><strong>3.3 How to get a number for a landline, a mobile phone, or set up internet?</strong></p>
            <p>You can log on to the official website of a Chinese telecom operator or visit their branches with your valid passport.</p>
            <p>CHINA MOBILE | www.10086.cn</p>
            <p>China unicom | www.10010.com</p>
            <p>CHINA TELECOM | www.chinatelecom.com.cn</p>
            <p>⚠️ Real-name authentication is required to apply for a SIM card in China. If you no longer use a number, you must cancel the account in branch.</p>
          </div>
        </template>
      </div>
    </van-popup>

    <span class="lang-switch" @click="$switchLang()">
      <span v-if="$lang === 'zh-CN'">EN</span>
      <span v-else>中文</span>
    </span>
  </div>
</template>
<script>
import Vue from "vue";
import { getImageStream } from '@/utils/index'
import uploadFile from '@/components/upload/uploadFile'
import { ImagePreview } from 'vant';
import { toPinyin, formatBuildingName, formatBuildingAddress } from './addressUtil'
export default {
  data() {
    return {
      showCover: false,
      time: 3,
      timer: null,
      openid:'',
      unionid:'',
      mobile:'',
      noticeListSafe: [],
      rawHouseName: '',
      rawHouseData: null,
      detailHouseName: '',
      houseId: '',
      managerNum: '',
      orgId: '',
      safeImg:'',
      noticeType:'',
      subareaId:'',
      noticeList: [],
      userInfoList: [],
      buildingId:'',
      url:'https://sgg.hzxh.gov.cn/police-api',
      // url:'http://192.168.0.108:8091',
      //管理员跳转到网格果果
      // adminurl:'http://192.168.0.76:8080/adminCode',
      type: 1, //1是房屋id,2是楼幢id
      id: '',
      current: 0,
      showVerify: false,
      dataForm: {
        mobile: '',
        code: ''
      },
      btnSendText: '发送验证码',
      btnSendChecked: false,
      timerCode: null,
      showTerms: false,
      streetName: ''
    }
  },
  computed: {
    houseName() {
      return this.formatHouseName(this.rawHouseName, this.rawHouseData || {})
    }
  },
  components: {
    uploadFile
  },
  destroyed() {
    clearInterval(this.timer)
    this.timer = null
    clearInterval(this.timerCode)
    this.timerCode = null
  },
  created() {
    if (this.$route.query.domain && this.$route.query.domain != 'null'&&!this.$route.query.p&&!this.$route.query.u){
      if (this.$route.query.domain == 'https://sgg.hzxh.gov.cn') {
        this.$route.query.domain = 'https://shgz.hzxh.gov.cn'
      }
      this.$http.changeUrl(this.$route.query.domain, true)
      this.$httpApp.changeUrl(this.$route.query.domain, true)
      this.$httpCustApp.changeUrl(this.$route.query.domain, true)
    }
    this.showCover = sessionStorage.getItem('showCover') !== '0'
    if (this.showCover) {
      setTimeout(() => {
        this.showCover = false
        clearInterval(this.timer)
        this.timer = null
        sessionStorage.setItem('showCover', '0')
      }, 3000)
      this.time = 3
      this.timer = setInterval(() => {
        this.time -= 1
      }, 1000)
    }
    if (this.$route.query.params) {
      Vue.prototype.$appid = 'wxfa4ce77dc91e7327'
      sessionStorage.setItem('appid', 'wxfa4ce77dc91e7327')
      this.openid = this.$route.query.p
      this.unionid = this.$route.query.u
      this.mobile = this.$route.query.m
      this.params = this.$route.query.params
      this.domain = this.$route.query.domain
      this.$nextTick(() => {
        if (!this.openid && !this.unionid){
          // if(this.isWeixinBrowser()) {
          //   如果是微信内部浏览器就打开小程序
          const param = `params=${this.$route.query.params}` + `&domain=${this.$route.query.domain}` + `&code=safet2ycode`
          this.$http({
            url: this.$http.adornUrl('/wxapp/getWxUrlScheme'),
            method: 'post',
            params: this.$http.adornParams({
              param
            })
          }).then(({data}) => {
            if (data && data.code === 0) {
              location.href =data.wxUrlScheme

            }
          })
          // }
        }
      })
    }
    this.getScanCodeParams()

  },
  methods: {
    onChange(index) {
      this.current = index;
    },
    getInfo(id) {
      this.$store.commit('setNoticeId', id)
      this.$router.push('/notice-info')
    },
    goNoticeSafe() {
      let tmp1=this.orgId|| Vue.prototype.$globalData.userInfo.orgId
      let tmp2=this.noticeType
      this.$router.push({path:'/notice',query:{orgId:tmp1,noticeType:tmp2}})
    },
    goNotice() {
      let tmp1=this.orgId|| Vue.prototype.$globalData.userInfo.orgId
      let tmp2=1
      this.$router.push({path:'/notice',query:{orgId:tmp1,isOpen:tmp2}})
    },
    openTerms() {
      this.showTerms = true
    },
    goProblem() {
      this.$router.push({path:'/saveCode-problem', query: {orgId: this.subareaId || this.orgId, address: this.detailHouseName, buildingId: this.buildingId, houseId: this.houseId}})
    },
    goHelp() {
      this.$router.push({path:'/saveCode-help', query: {orgId: this.orgId, address: this.detailHouseName, buildingId: this.buildingId, houseId: this.houseId}})
    },
    goImprove () {
      if (!sessionStorage.getItem('userMobile')) {
        this.dataForm.mobile = ''
        this.dataForm.code = ''
        this.showVerify = true
      } else {
        this.$router.push({path:'/saveCode-problem-list', query: {
          buildingId: this.buildingId,
          houseId: this.houseId,
          mobile: sessionStorage.getItem('userMobile'),
          placeType: this.houseId ? 2 : 1,
          orgId: this.orgId
        }})
      }
    },
    verifyConfirm () {
      if (!this.dataForm.mobile) {
        return this.$toast.fail('请输入联系电话')
      } else if (!this.btnSendChecked) {
        return this.$toast.fail('请先获取验证码')
      } else if (!this.dataForm.code) {
        return this.$toast.fail('请输入验证码')
      }
      this.$httpCustApp({
        url: 'https://api.hzuht.com/general/verify/verifyCode',
        method: 'post',
        params: this.$httpCustApp.adornParams({
          token: this.dataForm.mobile,
          code: this.dataForm.code
        })
      }).then(({ data }) => {
        if (data && data.code === 0){
          sessionStorage.setItem('userMobile', this.dataForm.mobile)
          sessionStorage.setItem('code', this.dataForm.code)
          this.$router.push({path:'/saveCode-problem-list', query: {
            buildingId: this.buildingId,
            houseId: this.houseId,
            mobile: this.dataForm.mobile,
            placeType: this.houseId ? 2 : 1,
            orgId: this.orgId
          }})
        }
      })
    },
    getCode () {
      if (!this.dataForm.mobile) {
        return this.$toast.fail('请输入联系电话')
      } else if (this.btnSendText != '发送验证码') {
        return
      }
      this.$httpCustApp({
        url: 'https://api.hzuht.com/general/verify/sendVerifyCode',
        method: 'post',
        params: this.$httpCustApp.adornParams({
          token: this.dataForm.mobile,
          mobile: this.dataForm.mobile,
          needExist: 1
        })
      }).then(({ data }) => {
        if (data && data.code === 0){
          this.$toast.success ({
            message: '发送成功',
            duration: 1500,
          })
          this.countDown()
          // this.dataForm.code = data.code
        } else {
          this.$toast.fail(data.msg)
        }
      })
    },
    countDown () {
      let that = this;
      let countDownNum = 60
      this.timerCode = setInterval( () => {
        countDownNum--;
        that.btnSendText = countDownNum
        that.btnSendChecked = true
        if (countDownNum == 0) {
          clearInterval(that.timerCode)
          that.timerCode = null
          that.btnSendText = '发送验证码'
        }
      }, 1000)
    },
    getMobile(value) {
      let result = [];
      for (let i = 0; i < value.length; i++) {
        if (i == 3 || i == 7) {
          result.push(" " + value.charAt(i));
        } else {
          result.push(value.charAt(i));
        }
      }
      return result.join('')
    },
    numChange(i) {
      let arry = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
      if (i <= 10) {
        return arry[i];
      }
      if (i % 10 == 0 && i < 100) {
        return arry[Math.floor(i / 10)] + "十";
      }
      if (i > 10 && i < 20) {
        return "十" + this.numChange(i - 10 * Math.floor(i / 10));
      }
      if (i > 20 && i < 100 && i % 10 != 0) {
        return arry[Math.floor(i / 10)] + "十" + numChange(i - 10 * Math.floor(i / 10));
      }
    },
    formatHouseName(houseName, data) {
      if (!houseName) return ''
      var parts = houseName.split('-')
      if (parts.length <= 2) return parts[parts.length - 1]

      var restParts = parts.slice(2)
      var isEn = this.$lang === 'en-US'

      if (!isEn) {
        return restParts.join('-')
      }

      if (data.houseId) {
        if (restParts.length === 1) {
          return toPinyin(restParts[0])
        }
        var subareaName = restParts[0]
        var houseFullName = restParts.slice(1).join('-')
        return toPinyin(subareaName) + ', ' + toPinyin(houseFullName)
      }

      if (restParts.length >= 2) {
        return formatBuildingAddress(restParts[0], restParts[restParts.length - 1], true)
      }
      return formatBuildingName(restParts[0], true)
    },
    getScanCodeParams() {
      this.$http({
        url: this.$http.adornUrl('/wxapp/scanCode/getScanCodeParams'),
        method: 'get',
        params: this.$http.adornParams({
          id: this.$route.query.params|| Vue.prototype.$qrcodeOptions
        })
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.houseId = data.data.houseId
          this.id = this.houseId
          this.buildingId = data.data.buildingId
          if (this.buildingId){
            this.type = 2
            this.id = this.buildingId
          }
          this.orgId = data.data.orgId
          this.detailHouseName = data.data.houseName
          this.rawHouseName = data.data.houseName
          this.rawHouseData = data.data
          if((this.unionid||Vue.prototype.$unionid)&&(this.openid||Vue.prototype.$openid)){
            this.isLogin()
          }
          this.getManager()
          this.getNoticeType()
          this.getNotice()
          this.getImg()
          if (this.orgId) {
            this.getStreetId(this.orgId)
          }
        }
      })
    },
    isLogin(){
      this.$http({
        url: this.$http.adornUrl(`/wxapp/scanCode/isLogin`),
        method: 'get',
        params: this.$http.adornParams({
          unionId: this.unionid||Vue.prototype.$unionid,
          openId:this.openid||Vue.prototype.$openid,
          orgId:this.orgId,
          houseId: this.houseId||''
        })
      }).then(({data}) => {
        if (data.code == 0 && data) {

          if(this.buildingId&&data.isAdmin==true){
            sessionStorage.setItem('token',data.token)
            this.$cookies.set('token',data.token)
            this.$router.replace({path:'/AdminCode',query:{buildingId:this.buildingId||Vue.prototype.$buildingId,mobile:this.mobile|| Vue.prototype.$purePhoneNumber,
                data:this.$route.query.params|| Vue.prototype.$qrcodeOptions,orgId:this.orgId||
                    Vue.prototype.$globalData.userInfo.orgId
                ,userId:data.userId,assistId:data.assistId}})
            return;
          }
          else if(data.isAdmin==false&&data.isLive==false){
            return
          }
          if(this.houseId&&(data.isAdmin==true||data.isLive==true)) {
            sessionStorage.setItem('token',data.token)
            this.$cookies.set('token',data.token)
            this.$route.query.userId=data.userId
            this.$router.replace({
              path: '/userReal',
              query:this.$route.query
            })
          }

          // this.subareaId = data.buildingInfo.subarea
          // this.$route.query.type = 'zuke'
          // this.$route.query.subareaId = this.subareaId
          // this.$route.query.buildingId = this.buildingId
          // this.$router.push({ path: '/sso', query: this.$route.query})
        }
      })
    },
    getImg() {
      this.$http({
        url: this.$http.adornUrl(`/wxapp/building/info/getFireImg`),
        method: 'get',
        params: this.$http.adornParams({
          id: this.id,
          type: this.type
        })
      }).then(({ data }) => {
        if (data && data.code === 0) {
          if (data.info.subarea) this.subareaId = data.info.subarea
          // this.safeImg=[{fileType:'image',relativePath:data.info.fireSafetyImg}]
          this.safeImg=data.info.fireSafetyImg?getImageStream(data.info.fireSafetyImg):''
          // this.safeImg=''
        }
      })
    },
    imgPreView (path) {
      ImagePreview({
        images: [path],
        startPosition: 0,
        closeable: true,
      });
    },
    getNotice() {
      this.$httpApp({
        url: this.$httpApp.adornUrl(`/wxapp/commonApp/notice/listWithoutToken`),
        method: 'post',
        params: this.$httpApp.adornParams({
          page: 1,
          limit: 2,
          logInOrgId: this.orgId|| Vue.prototype.$globalData.userInfo.orgId,
          orgUserId: 0,
          isOpen: 1
        })
      }).then(({ data }) => {
        if (data && data.code == 0) {
          this.noticeList=data.page.list
        }
      })
    },
    getNoticeType() {
      this.$http({
        url: this.$http.adornUrl(`/sys/dict/listDictByCode`),
        method: 'get',
        params: this.$http.adornParams({
          code: 'noticeType',
          orgId: this.orgId|| Vue.prototype.$globalData.userInfo.orgId
        })
      }).then(({ data }) => {
        if (data && data.code == 0) {
          data.dicts.forEach(item => {
            if (item.label === '平安宣传' && item.parameters.type === 'safetyCode') {
              this.noticeType = item.value
            }
          })
          this.getNoticeSafe()
        }
      })
    },
    getNoticeSafe() {
      this.$httpApp({
        url:this.$httpApp.adornUrl( `/wxapp/commonApp/notice/listWithoutToken`),
        method: 'post',
        params: this.$httpApp.adornParams({
          page: 1,
          limit: 9,
          logInOrgId: this.orgId|| Vue.prototype.$globalData.userInfo.orgId,
          orgUserId: 0,
          noticeType: this.noticeType
        })
      }).then(({ data }) => {
        if (data && data.code == 0) {
          this.noticeListSafe=data.page.list
        }
      })
    },
    getManager() {
      this.$httpApp({
        url: this.$httpApp.adornUrl( `/building/manager/info/getManager/${this.id}`),
        method: 'get',
        params: this.$httpApp.adornParams({
          type: this.type
        })
      }).then(({ data }) => {
        if (data && data.code === 0) {
          let tmp = data.managers
          data.managers.map((item, index) => {
            tmp[index].avatar = getImageStream(item.avatar)
            tmp[index].nameEn = toPinyin(item.name)
          })
          this.userInfoList = tmp
          this.managerNum = this.numChange(data.managers.length)
        }
      })
    },
    // 根据社区id获取街道id
    getStreetId(id) {
      this.$http({
        url: this.$http.adornUrl(`/sys/org/noLogin/info/${id}`),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({data}) => {
        if (data.code == 0 && data) {
          let street = data.sysOrg.path.split(',')
          let newStreet = street.splice(0, street.length - 1)
          this.streetPath = newStreet.slice(1).toString()
          if (data.sysOrg.parentName) {
            this.streetName = data.sysOrg.parentName
          }
        }
      })
    },
    // 根据楼幢id获取小区楼幢
    getBuildingId(id) {
      this.$http({
        url: this.$http.adornUrl(`/building/info/noLogin/info/${id}`),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({data}) => {
        if (data.code == 0 && data) {
          this.subareaId = data.buildingInfo.subarea
          this.$route.query.type = 'zuke'
          this.$route.query.subareaId = this.subareaId
          this.$route.query.buildingId = this.buildingId
          this.$router.push({ path: '/newRegister', query: this.$route.query})
        }
      })
    },
    toLogin() {
      //+ `&path=${encodeURIComponent('pages/login/login')}`
      const param = `params=${this.$route.query.params||Vue.prototype.$qrcodeOptions}` + `&domain=${this.$route.query.domain||  Vue.prototype.$globalData.domain}`+ `&streetId=${this.streetPath||  Vue.prototype.$globalData.userInfo.street}`
      this.$http({
        url: this.$http.adornUrl('/wxapp/getWxUrlScheme'),
        method: 'post',
        params: this.$http.adornParams({
          param,
          path: '/pages/login/login'
        })
      }).then(({ data }) => {
        if (data && data.code === 0){
          location.href = data.wxUrlScheme
        }
      })
    },
    toRegister() {
      if (this.buildingId){
        this.getBuildingId(this.buildingId)
      }else if (this.houseId){
        console.log( this.$route.query)
        this.$route.query.type = 'zuke'
        this.$router.push({ path: '/newRegister', query: this.$route.query })
      } else {
        this.$message.error("页面加载未完成,请稍后再试!")
      }
    }
  }
}
</script>
<style scoped lang="scss">
.cover {
  position: relative;
  z-index: 100;
  width: 100vw;
  .time {
    font-family: DINPro-Bold;
    font-size: 24px;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border: 2px solid #fff;
    border-radius: 50%;
    color: #fff;
    position: fixed;
    top: 30px;
    right: 30px;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
.save-code {
  font-family: PingFangSC-Regular;
  overflow: auto;
  min-height: 100vh;
  width: 100vw;
  background: linear-gradient(180deg, #e0ebff 0%, #f5f6fa 40%);
  padding-bottom: 24px;

  .banner {
    position: relative;
    background: linear-gradient(180deg, #e0ebff 0%, #ffffff 100%);
    border-radius: 24px;
    margin: 24px 30px 32px;
    overflow: hidden;
  }
  .banner-dots {
    position: absolute; top: 20px; left: 24px;
    display: grid; grid-template-columns: 1fr 1fr; gap: 6px;
  }
  .dot {
    width: 16px; height: 16px;
    background: rgba(64, 128, 255, 0.2); border-radius: 4px;
  }
  .banner-lines {
    position: absolute; top: 52px; left: 24px;
    display: flex; flex-direction: column; gap: 6px;
  }
  .line {
    width: 20px; height: 3px;
    background: rgba(64, 128, 255, 0.14); border-radius: 2px;
  }
  .banner-title {
    font-size: 36px; font-weight: 600; color: #555;
    margin: 0; padding: 40px 0 28px; text-align: center;
  }
  .banner-row {
    display: flex; justify-content: space-between; align-items: center;
    padding: 0 30px 32px; position: relative; z-index: 1;
  }
  .banner-house {
    font-size: 44px; font-weight: 700; color: #4080ff;
  }
  .banner-btns {
    display: flex; gap: 16px;
  }
  .banner-btn-outline {
    padding: 14px 32px; border: 2px solid #4080ff; border-radius: 12px;
    background: #fff; color: #4080ff; font-size: 26px; font-weight: 500;
    white-space: nowrap; flex-shrink: 0;
  }
  .banner-btn-primary {
    padding: 14px 32px; border-radius: 12px;
    background: #4080ff; color: #fff; font-size: 26px; font-weight: 500;
    white-space: nowrap; flex-shrink: 0;
  }
  .banner-svg {
    position: absolute; bottom: 0; left: 0; right: 0;
    height: 64px; width: 100%; color: #4080ff;
  }

  .notice-card, .terms-card {
    margin: 32px 30px 32px;
    background: #fff; border-radius: 24px; padding: 30px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }
  .notice-card-row, .terms-card-row {
    display: flex; justify-content: space-between; align-items: center;
  }
  .notice-card-title, .terms-card-title {
    font-size: 34px; font-weight: 700; color: #222; margin: 0 0 12px;
  }
  .notice-card-sub, .terms-card-sub {
    font-size: 28px; color: #999; margin: 0;
  }

  .user-info {
    margin: 0 30px 32px;
    padding: 30px;
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border-radius: 24px;

    .user-info-title {
      line-height: 44px;
      color: #192558;
      font-size: 32px;
      font-weight: bold;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 18px;
    }

    .user-info-item {
      width: calc(50% - 6px);
      background: linear-gradient( 180deg, #F0F9FF 0%, #FDFFFF 100%);
      display: flex;
      padding: 44px 10px;
      margin-bottom: 10px;
      border-radius: 16px;
      img {
        width: 120px;
        height: 120px;
        margin-right: 12px;
        flex-shrink: 0;
      }

      .post {
        font-size: 28px;
        color: #333;
        line-height: 36px;
        margin-top: 4px;
      }

      .name {
        font-size: 24px;
        color: #333;
        line-height: 36px;
        margin-top: 4px;
      }

      .mobile {
        font-size: 20px;
        color: #929AB9;
        line-height: 34px;
        margin-top: 4px;
      }
    }
  }
}

.verify {
  padding-top: 30px;
  ::v-deep .van-field__label {
    display: flex; align-items: center;
  }
}
.btnSendText {
  color: #1989fa;
  margin-right: 40px;
}

.terms-popup {
  border-radius: 24px 24px 0 0;
}
.terms-header {
  padding: 28px 30px 18px; border-bottom: 1px solid #eee;
  text-align: center; position: relative;
}
.terms-title {
  font-size: 32px; font-weight: 600; color: #222; margin: 0;
}
.terms-subtitle {
  font-size: 24px; color: #999; margin: 8px 0 0;
}
.terms-close {
  position: absolute; right: 24px; top: 22px;
  font-size: 36px; color: #999; line-height: 1; cursor: pointer;
}
.terms-body {
  max-height: 50vh; overflow-y: auto; padding: 24px 30px;
  font-size: 26px; color: #666; line-height: 1.8;
}
.terms-section {
  margin-bottom: 24px;
  h4 { font-size: 28px; font-weight: 600; color: #333; margin: 0 0 10px; }
  h5 { font-size: 26px; font-weight: 600; color: #555; margin: 0 0 8px; }
  p { margin: 0 0 6px; }
  strong { color: #4080ff; }
  .terms-tip { color: #999; font-style: italic; margin-top: 8px; }
}

.lang-switch {
  position: fixed; bottom: 160px; right: 30px; z-index: 50;
  background: #4080ff; color: #fff; padding: 12px 28px;
  border-radius: 32px; font-size: 24px; font-weight: 500;
  box-shadow: 0 4px 16px rgba(64, 128, 255, 0.35);
  &:active { opacity: 0.8; }
}
</style>
